// src/features/customers/components/CustomerStatusBadge.tsx
import clsx from 'clsx';
import type { CustomerStatus } from '../customer.types';

const STATUS_CONFIG: Record<CustomerStatus, { label: string; className: string }> = {
  active: {
    label: 'فعال',
    className: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20',
  },
  inactive: {
    label: 'غیرفعال',
    className: 'text-slate-400 bg-slate-400/10 border-slate-400/20',
  },
  suspended: {
    label: 'معلق',
    className: 'text-rose-400 bg-rose-400/10 border-rose-400/20',
  },
};

interface CustomerStatusBadgeProps {
  status: CustomerStatus;
}

export function CustomerStatusBadge({ status }: CustomerStatusBadgeProps) {
  const { label, className } = STATUS_CONFIG[status];

  return (
    <span
      className={clsx(
        'inline-flex shrink-0 items-center rounded-full border px-2.5 py-1 text-xs font-medium',
        className,
      )}
    >
      {label}
    </span>
  );
}
